import { Pencil2Icon, TriangleRightIcon } from "@radix-ui/react-icons";
import clsx from "clsx";
import dayjs from "dayjs";
import parse from "parse-duration";
import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import ReactDOM from "react-dom";
import {
  ProjectResourceAllocationData,
  useCreateResourceAllocation,
  useDeleteResourceAllocation,
  useGetProjectResourceAllocations,
  useUpdateResourceAllocation,
} from "src/api/resources/resources";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "src/components/ui/command";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "src/components/ui/dropdown-menu";
// import AutoSizer from "react-virtualized-auto-sizer";
// import { VariableSizeList as List } from "react-window";
import { EllipsisVerticalIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useGetRoles } from "src/api/Misc/Settings/roles/roles";
import {
  useAddInternalMemberToProject,
  useGetProjectMembers,
} from "src/api/Services/Projects/projects";
import {
  useGetPhase,
  useUpdatePhase,
} from "src/api/Services/SharedSpace/phases";
import { useGetTaskersForInstance } from "src/api/Services/Tasks/tasks";
import { Button } from "src/components/ui/button";
import { Dialog, DialogContent } from "src/components/ui/dialog";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "src/components/ui/popover";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/components/ui/select";
import { TextInput } from "src/components/ui/text-input";
import { getFirstAndLastInitials } from "src/utils/functions/avatar";
import { convertMsToNatural, getDateOfMonday } from "../timesheets/timesheets";
import {
  ResourcesContextProvider,
  useResourcesContext,
} from "./resources-context-provider";
type Props = {};

export default function Resources({}: Props) {
  return (
    <ResourcesContextProvider>
      <div className="flex h-full flex-col overflow-y-auto">
        <div className="flex h-12 shrink-0 items-center border-b border-gray-200/70 px-8">
          <div className="flex select-none items-center space-x-2 text-sm">
            Resources
          </div>
        </div>
        <div className="flex h-14 shrink-0 items-center space-x-2 border-b border-gray-300/70 px-8">
          <Button variant={"secondary"}>Filter</Button>
          <ZoomSelect />
          {/* <Button
          onClick={() => {
            // console.log(dayjs().startOf("week").add(1, "day").toISOString());
            // createResourceAllocationMutation.mutate({
            //   phaseId: "66d8a2c5886284a1219def87",
            //   userId: "65841c7048fcc041f5bb4f66",
            //   allocationType: "hard",
            //   endDate: dayjs().startOf("week").add(8, "day").toISOString(),
            //   startDate: dayjs().startOf("week").add(1, "day").toISOString(),
            //   timePerWeek: 32,
            // });
          }}
        >
          Add Allocation
        </Button> */}
        </div>
        {/* <div className="pb-8"> */}
        <Testing3 />
        {/* </div> */}
      </div>
    </ResourcesContextProvider>
  );
}

function ZoomSelect() {
  const resourcesCtx = useResourcesContext();
  return (
    <Select
      value={String(resourcesCtx.state.dayWidth)}
      onValueChange={(value) => {
        resourcesCtx.dispatch({
          type: "SET_DAY_WIDTH",
          width: parseInt(value),
        });
      }}
    >
      <SelectTrigger className="w-32">
        {resourcesCtx.state.dayWidth === 18 ? "Week" : "Month"}
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={"18"}>Week</SelectItem>
        <SelectItem value={"8"}>Month</SelectItem>
      </SelectContent>
    </Select>
  );
}

interface TimelineItem {
  id: number;
  date: string;
}

type SelectedCells = {
  [projectId: string]: {
    [date: string]: boolean;
  };
};

function getOrdinalSuffix(dateString: string): string {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date string provided");
  }

  const day: number = date.getDate();
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

const PROJECT_COLUMN_WIDTH = 320;
const ALLOCATED_COLUMN_WIDTH = 120;
const RESOURCE_ALLOCATION_HEIGHT = 32;
// const CELL_WIDTH = 124;

function Testing3() {
  const { data: projectResourceAllocations } =
    useGetProjectResourceAllocations();
  // console.log(projectResourceAllocations);

  // console.log(projectResourceAllocations);
  // console.log(projectResourceAllocations);
  // const [projectResourceAllocations, setProjectResourceAllocations] =
  //   useState<ProjectResourceAllocationData[]>(projectAllocations);
  // console.log(projectResourceAllocations);
  const [scrollLeft, setScrollLeft] = useState<number>(0);
  const [timeline, setTimeline] = useState<TimelineItem[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);
  const timelineRef = useRef<HTMLDivElement>(null);
  const [selectedCells, setSelectedCells] = useState<SelectedCells[]>([]);
  const resourcesCtx = useResourcesContext();
  // Generate initial timeline
  useEffect(() => {
    const today = new Date();
    // const sixWeeksAgo = new Date(today.getTime() - 6 * 7 * 24 * 60 * 60 * 1000);
    // sixWeeksAgo.setDate(sixWeeksAgo.getDate() - sixWeeksAgo.getDay());
    // const initialTimeline = generateTimeline(getDateOfMonday(sixWeeksAgo), 26);
    const startDate = getDateOfMonday(dayjs(today).toDate());
    const pastTimeline = generateTimeline(
      dayjs(startDate).subtract(1, "week").toDate(),
      20,
      "past"
    );
    const futureTimeline = generateTimeline(startDate, 20, "future");
    setTimeline([...pastTimeline, ...futureTimeline]);
    setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.scrollLeft = 20 * resourcesCtx.state.dayWidth * 7;
      }
    }, 0);
    // setTimeline(initialTimeline);
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      // center the scroll
      containerRef.current.scrollLeft =
        (containerRef.current.scrollWidth - containerRef.current.clientWidth) /
        2;
    }
  }, [resourcesCtx.state.dayWidth]);

  const [isDragging, setIsDragging] = useState(false);
  // src/pages/resources/resources.tsx

  const generateTimeline = (
    startDate: Date,
    weeks: number,
    direction: "future" | "past" = "future"
  ): TimelineItem[] => {
    return Array.from({ length: weeks }, (_, weekIndex) => {
      const week =
        direction === "future"
          ? dayjs(startDate).add(weekIndex, "week")
          : dayjs(startDate).subtract(weeks - weekIndex - 1, "week");

      return {
        id: direction === "future" ? weekIndex : -weekIndex,
        date: week.format("YYYY-MM-DD"),
        weekStart: week.startOf("week").format("YYYY-MM-DD"),
        weekEnd: week.endOf("week").format("YYYY-MM-DD"),
      };
    });
  };

  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      // scrollLeft = how far to the left we've scrolled in pixels
      // scrollWidth = the total width of the container in pixels
      // clientWidth = the width of the visible area of the container in pixels
      const { scrollLeft, scrollWidth, clientWidth } = e.currentTarget;
      setScrollLeft(scrollLeft);

      if (timelineRef.current) {
        timelineRef.current.scrollLeft = scrollLeft;
      }

      const threshold = 1000;

      // Append more weeks if near the right end
      if (scrollWidth - (scrollLeft + clientWidth) < threshold) {
        const lastDate = dayjs(timeline[timeline.length - 1].date)
          .add(1, "week")
          .toDate();
        const newItems = generateTimeline(lastDate, 30, "future");
        setTimeline((prev) => [...prev, ...newItems]);
      }
      // Prepend more weeks if near the left end
      if (scrollLeft < threshold) {
        const firstDate = dayjs(timeline[0].date).subtract(1, "week").toDate();
        const newPastItems = generateTimeline(firstDate, 30, "past");
        setTimeline((prev) => [...newPastItems, ...prev]);

        // Adjust scroll to maintain the current view after prepending
        if (containerRef.current) {
          containerRef.current.scrollLeft +=
            30 * resourcesCtx.state.dayWidth * 7;
        }
      }

      // Check if we're near the end of the timeline
      // if (scrollWidth - (scrollLeft + clientWidth) < threshold) {
      //   // Generate more timeline items
      //   const lastDate = dayjs(timeline[timeline.length - 1].date).toDate();
      //   const newItems = generateTimeline(
      //     dayjs(lastDate).add(1, "week").toDate(),
      //     30
      //   );
      //   setTimeline((prevTimeline) => [...prevTimeline, ...newItems]);
      // }
    },
    [timeline]
  );

  const [someProjectIsExpanded, setSomeProjectIsExpanded] = useState(false);

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div
        className="flex-1 overflow-auto"
        ref={containerRef}
        onScroll={handleScroll}
      >
        <div
          className="sticky top-0 z-10 flex border-b border-gray-200"
          style={{
            width: `${
              resourcesCtx.state.dayWidth * 7 * timeline.length +
              PROJECT_COLUMN_WIDTH +
              ALLOCATED_COLUMN_WIDTH +
              ALLOCATED_COLUMN_WIDTH
            }px`,
          }}
        >
          <div className="sticky left-0 z-10 shrink-0 border-r-2 border-gray-300/70 ">
            <div className="sticky top-0 z-10 flex h-16 items-center border-b border-gray-200/70 bg-gray-100 text-sm">
              <div
                className={`flex h-full flex-1 items-center px-8 w-[${PROJECT_COLUMN_WIDTH}px]`}
              >
                Project
              </div>
              <div
                className={`flex h-full items-center border-l border-gray-200/70  px-6 w-[${ALLOCATED_COLUMN_WIDTH}px]`}
              >
                Budgeted
              </div>
              <div
                className={`flex h-full items-center border-l border-gray-200/70  px-6 w-[${ALLOCATED_COLUMN_WIDTH}px]`}
              >
                Allocated
              </div>
            </div>
          </div>
          <div className="h-16 w-full">
            <div className="flex">
              {timeline.map((item, index) => {
                if (index === 0) {
                  const numberOfDaysLeftInMonth =
                    dayjs(item.date).daysInMonth() -
                    dayjs(item.date).date() +
                    1;
                  return (
                    <div
                      key={item.date}
                      className={`flex h-6 shrink-0 items-center truncate border-b border-r bg-gray-50 px-2 text-xs`}
                      style={{
                        width: `${
                          numberOfDaysLeftInMonth * resourcesCtx.state.dayWidth
                        }px`,
                      }}
                    >
                      {dayjs(item.date).format("MMM")}
                    </div>
                  );
                } else {
                  const firstDayOfMonth = dayjs(item.date).startOf("month");
                  const endOfWeek = dayjs(item.date).add(6, "day");
                  const isEndOfWeekInNextMonth =
                    endOfWeek.isAfter(firstDayOfMonth.add(1, "month")) ||
                    endOfWeek.isSame(firstDayOfMonth.add(1, "month"));
                  if (isEndOfWeekInNextMonth) {
                    const daysInNextMonth = dayjs(item.date)
                      .add(1, "month")
                      .daysInMonth();
                    return (
                      <div
                        key={item.date}
                        className={`flex h-6 shrink-0 items-center truncate border-b border-r bg-gray-50 px-2 text-xs`}
                        style={{
                          width: `${
                            daysInNextMonth * resourcesCtx.state.dayWidth
                          }px`,
                        }}
                      >
                        {dayjs(item.date).add(1, "month").format("MMM")}
                      </div>
                    );
                  } else {
                    // check if first day of month
                    const firstDayOfMonth = dayjs(item.date).startOf("month");
                    const isFirstDayOfMonth = dayjs(item.date).isSame(
                      firstDayOfMonth,
                      "day"
                    );
                    const daysInMonth = dayjs(item.date).daysInMonth();
                    if (isFirstDayOfMonth) {
                      return (
                        <div
                          key={item.date}
                          className={`flex h-6 shrink-0 items-center truncate border-b border-r bg-gray-50 px-2 text-xs`}
                          style={{
                            width: `${
                              daysInMonth * resourcesCtx.state.dayWidth
                            }px`,
                          }}
                        >
                          {dayjs(item.date).format("MMM")}
                        </div>
                      );
                    }
                  }
                  return null;
                }
                // const firstDayOfMonth = dayjs(item.date).startOf("month");
                // const isFirstDayOfMonth = dayjs(item.date).isSame(
                //   firstDayOfMonth,
                //   "day"
                // );
                // if (isFirstDayOfMonth) {
                //   return (
                //     <div
                //       key={item.date}
                //       className={`flex h-6 shrink-0 items-center truncate border-l border-b bg-gray-50 px-4 text-xs`}
                //       style={{
                //         width: `${CELL_WIDTH}px`,
                //       }}
                //     >
                //       {dayjs(item.date).format("MMM")}
                //     </div>
                //   );
                // } else {
                //   const endOfWeek = dayjs(item.date).add(6, "day");
                //   const isEndOfWeekInNextMonth =
                //     endOfWeek.isAfter(firstDayOfMonth.add(1, "month")) ||
                //     endOfWeek.isSame(firstDayOfMonth.add(1, "month"));
                //   if (isEndOfWeekInNextMonth) {
                //     // number of days to end of month
                //     const numberOfDaysToEndOfMonth =
                //       dayjs(item.date).daysInMonth() -
                //       dayjs(item.date).date() +
                //       1;
                //     const numberOfDaysInNextMonth =
                //       7 - numberOfDaysToEndOfMonth;
                //     console.log(
                //       dayjs(item.date).format("MMM DD"),
                //       numberOfDaysToEndOfMonth,
                //       numberOfDaysInNextMonth
                //     );
                //     return (
                //       <div className="flex">
                //         <div
                //           key={item.date}
                //           className={`flex h-6 shrink-0 items-center truncate border-b bg-red-50 text-xs`}
                //           style={{
                //             width: `${
                //               (numberOfDaysToEndOfMonth / 7) * CELL_WIDTH
                //             }px`,
                //           }}
                //         >
                //           {dayjs(item.date).format("MMM")}
                //         </div>
                //         <div
                //           key={item.date}
                //           className={`flex h-6 shrink-0 items-center truncate border-l border-b bg-blue-50 text-xs`}
                //           style={{
                //             width: `${
                //               (numberOfDaysInNextMonth / 7) * CELL_WIDTH
                //             }px`,
                //           }}
                //         >
                //           {dayjs(item.date).add(6, "day").format("MMM")}
                //         </div>
                //       </div>
                //     );
                //   }
                //   return (
                //     <div
                //       key={item.date}
                //       className={`flex h-6 shrink-0 items-center truncate border-b bg-gray-100 px-4 text-xs`}
                //       style={{
                //         width: `${CELL_WIDTH}px`,
                //       }}
                //     >
                //       {/* {dayjs(item.date).format("MMM")} */}
                //     </div>
                //   );
                // }
                // // number of days in the month
                // const daysInMonth = dayjs(item.date).daysInMonth();
                // const monthWidth = (daysInMonth * CELL_WIDTH) / 7;
                // return (
                //   <div
                //     key={item.date}
                //     className={`flex h-6 shrink-0 items-center truncate border-r border-b bg-gray-50 px-4 text-xs`}
                //     style={{
                //       width: `${monthWidth}px`,
                //     }}
                //   >
                //     {dayjs(item.date).format("MMM")}
                //   </div>
                // );
              })}
            </div>
            <div className="flex">
              {timeline.map((item) => (
                <div
                  key={item.date}
                  className={`flex h-10 shrink-0 items-center truncate border-r border-b bg-gray-50 px-4 text-xs`}
                  style={{
                    width: `${resourcesCtx.state.dayWidth * 7}px`,
                  }}
                >
                  {resourcesCtx.state.dayWidth === 18 && (
                    <>
                      {dayjs(item.date).format("MMM DD") +
                        " - " +
                        dayjs(item.date).add(6, "day").format("MMM DD")}
                    </>
                  )}
                </div>
              ))}
              {/* </div> */}
            </div>
          </div>
        </div>
        <div
          className="relative z-0"
          style={{
            width: `${
              resourcesCtx.state.dayWidth * 7 * timeline.length +
              PROJECT_COLUMN_WIDTH +
              ALLOCATED_COLUMN_WIDTH +
              ALLOCATED_COLUMN_WIDTH
            }px`,
          }}
        >
          {projectResourceAllocations?.map((projectResourceAllocation) => (
            <ProjectRow
              key={projectResourceAllocation.projectId}
              projectResourceAllocation={projectResourceAllocation}
              timeline={timeline}
              // setProjectResourceAllocations={setProjectResourceAllocations}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

// convert ms to format of 00h 00m but 00m if hours is 0 then just 00m
function convertMsToHM(ms: number): string {
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  if (hours === 0) {
    return `${minutes}m`;
  }
  return `${hours}h ${minutes}m`;
}

function ProjectRow({
  projectResourceAllocation,
  timeline,
}: // setProjectResourceAllocations,
{
  projectResourceAllocation: ProjectResourceAllocationData;
  timeline: TimelineItem[];
  // setProjectResourceAllocations: Dispatch<
  //   SetStateAction<ProjectResourceAllocationData[]>
  // >;
}) {
  const resourcesCtx = useResourcesContext();
  const [selectedCells, setSelectedCells] = useState<SelectedCells[]>([]);
  const [expanded, setExpanded] = useState(false);
  const allocatedInMs = projectResourceAllocation.users.reduce((acc, user) => {
    return (
      acc +
      user.allocations.reduce((acc, allocation) => {
        const weeksInAllocation =
          dayjs(allocation.endDate).diff(allocation.startDate, "week") + 1;
        return acc + allocation.timePerWeek * weeksInAllocation;
      }, 0)
    );
  }, 0);
  return (
    <div
      key={projectResourceAllocation.projectId}
      className="border-b border-gray-200 last:mb-20"
    >
      <div
        className="group flex cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="group sticky left-0 z-10 flex h-14 shrink-0 border-r-2 border-gray-200 bg-white group-hover:bg-gray-50">
          <div
            className={`w-[${PROJECT_COLUMN_WIDTH}px] flex items-center gap-2 px-8 pl-6 text-sm font-medium`}
          >
            <div
              className={clsx(
                "flex h-6 w-6 shrink-0 items-center justify-center rounded-md transition-all group-hover:bg-gray-100",
                expanded
                  ? "text-gray-600"
                  : "text-gray-300 group-hover:text-gray-400"
              )}
            >
              <TriangleRightIcon
                className={clsx(
                  "h-4 w-4 transition-transform",
                  expanded ? "rotate-90" : "rotate-0"
                )}
              />
            </div>

            <div className="truncate">
              {projectResourceAllocation.project.name}
            </div>
          </div>
          <div
            className={`w-[${ALLOCATED_COLUMN_WIDTH}px] flex items-center border-l border-gray-200/70 pl-6 text-sm font-medium`}
          >
            {!!projectResourceAllocation.project.budgetedTime
              ? convertMsToHM(projectResourceAllocation.project.budgetedTime)
              : "-"}
          </div>
          <div
            className={`w-[${ALLOCATED_COLUMN_WIDTH}px] flex items-center border-l border-gray-200/70 pl-6 text-sm font-medium`}
          >
            {convertMsToHM(allocatedInMs)}
          </div>
        </div>
        <div className="relative flex h-14 w-full group-hover:bg-gray-50">
          {timeline.map((item) => (
            <div
              key={item.date}
              className={`flex h-14 shrink-0 items-center truncate border-r border-r-gray-100`}
              style={{
                width: `${resourcesCtx.state.dayWidth * 7}px`,
              }}
              onMouseDown={() => {}}
            />
          ))}
          {projectResourceAllocation.project.startDate &&
            projectResourceAllocation.project.endDate && (
              <ProjectTimeline
                startDate={projectResourceAllocation.project.startDate}
                endDate={projectResourceAllocation.project.endDate}
                timeline={timeline}
                isExpanded={expanded}
              />
            )}
        </div>
      </div>
      {expanded && (
        <>
          {projectResourceAllocation.users.map((user) => (
            <ResourceRow
              resource={{
                type: "user",
                user: user,
              }}
              key={user.userId}
              timeline={timeline}
              projectId={projectResourceAllocation.projectId}
              // setProjectResourceAllocations={setProjectResourceAllocations}
            />
          ))}
          {projectResourceAllocation.roles.map((role) => (
            <ResourceRow
              resource={{
                type: "role",
                role: role,
              }}
              key={role.roleId}
              timeline={timeline}
              projectId={projectResourceAllocation.projectId}
            />
          ))}
          <div className="flex">
            <div className="group sticky left-0 z-20 flex h-14 shrink-0 cursor-pointer items-center truncate border-r-2 border-gray-200 bg-white text-sm font-medium">
              <div
                className={`flex h-full flex-1 items-start gap-2 truncate pl-14 pt-2 pr-8`}
                style={{
                  width: `${PROJECT_COLUMN_WIDTH}px`,
                }}
              >
                <AddUserButton phaseId={projectResourceAllocation.projectId} />
                {/* <AddRoleButton phaseId={projectResourceAllocation.projectId} /> */}
              </div>
              <div
                className={`flex h-full items-center border-l px-6 w-[${ALLOCATED_COLUMN_WIDTH}px]`}
              />
              <div
                className={`flex h-full items-center border-l px-6 w-[${ALLOCATED_COLUMN_WIDTH}px]`}
              />
            </div>
            <div className="relative flex h-14 w-full">
              {timeline.map((item) => (
                <div
                  key={item.date}
                  className={`relative flex h-14 shrink-0 items-center truncate border-r border-r-gray-100`}
                  style={{
                    width: `${resourcesCtx.state.dayWidth * 7}px`,
                  }}
                />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

function AddUserButton({ phaseId }: { phaseId: string }) {
  const [open, setOpen] = useState(false);
  const addInternalMemberMutation = useAddInternalMemberToProject();
  const { data: projectMembers } = useGetProjectMembers(phaseId);
  const { data: taskers } = useGetTaskersForInstance();
  const options = useMemo(() => {
    return taskers?.filter(
      (tasker) =>
        !projectMembers?.internal.find((member) => member._id === tasker._id)
    );
  }, [projectMembers, taskers]);
  const updatePhaseMutation = useUpdatePhase();
  const { data: roles } = useGetRoles();
  const { data: phase } = useGetPhase(phaseId);
  return (
    <>
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary">Add Resource</Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuGroup>
            <DropdownMenuSub>
              <DropdownMenuSubTrigger>Add User</DropdownMenuSubTrigger>
              <DropdownMenuSubContent className="p-0" sideOffset={8}>
                {options?.length ? (
                  <Command>
                    <CommandInput
                      placeholder="Search user..."
                      className="h-9"
                    />
                    <CommandList>
                      <CommandEmpty>No user found.</CommandEmpty>
                      <CommandGroup>
                        {options?.map((tasker) => (
                          <CommandItem
                            key={tasker._id}
                            value={tasker.name}
                            onSelect={() => {
                              addInternalMemberMutation.mutate({
                                phaseId: phaseId,
                                userId: tasker._id,
                                role: "member",
                              });
                              setOpen(false);
                            }}
                          >
                            {tasker.name}
                          </CommandItem>
                        ))}
                      </CommandGroup>
                    </CommandList>
                  </Command>
                ) : (
                  <div className="w-40 cursor-default px-2 py-1.5 text-sm">
                    All users added.
                  </div>
                )}
              </DropdownMenuSubContent>
            </DropdownMenuSub>
            <DropdownMenuSub>
              <DropdownMenuSubTrigger>Add Role</DropdownMenuSubTrigger>
              <DropdownMenuSubContent className="p-0" sideOffset={8}>
                <Command>
                  <CommandInput placeholder="Search role..." className="h-9" />
                  <CommandList>
                    <CommandEmpty>No role found.</CommandEmpty>
                    <CommandGroup>
                      {roles
                        ?.filter((role) => role.type === "internal")
                        .map((role) => (
                          <CommandItem
                            key={role._id}
                            value={role.name}
                            onSelect={() => {
                              updatePhaseMutation.mutate({
                                phase: {
                                  _id: phaseId,
                                  internalRoles: [
                                    ...(phase?.internalRoles || []),
                                    {
                                      _id: role._id,
                                      name: role.name,
                                    },
                                  ],
                                },
                                update: {
                                  _id: phaseId,
                                  internalRoles: [
                                    ...(phase?.internalRoles || []),
                                    {
                                      _id: role._id,
                                      // name: role.name,
                                    },
                                  ],
                                },
                              });
                              setOpen(false);
                            }}
                          >
                            {role.name}
                          </CommandItem>
                        ))}
                    </CommandGroup>
                  </CommandList>
                </Command>
              </DropdownMenuSubContent>
            </DropdownMenuSub>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}

function ProjectTimeline({
  startDate,
  endDate,
  timeline,
  isExpanded,
}: {
  startDate: string;
  endDate: string;
  timeline: TimelineItem[];
  isExpanded: boolean;
}) {
  // console.log(startDate)
  const resourcesCtx = useResourcesContext();
  const startIndex = timeline.findIndex((item) =>
    dayjs(startDate).subtract(1, "week").isBefore(item.date, "day")
  );
  const endIndex = timeline.findIndex((item) =>
    dayjs(item.date).add(1, "week").isAfter(endDate, "day")
  );
  if (startIndex === -1 || endIndex === -1) return null;
  const weeksInAllocation = endIndex - startIndex + 1;
  const width = weeksInAllocation * resourcesCtx.state.dayWidth * 7;
  return (
    <div
      className={clsx(
        `absolute top-1/2 z-0 flex justify-between px-1 text-[11px] h-[${12}px] -translate-y-1/2 overflow-hidden rounded border bg-gray-100`,
        isExpanded && "border-gray-300 bg-gray-200"
      )}
      style={{
        left: `${startIndex * resourcesCtx.state.dayWidth * 7}px`,
        width: `${width}px`,
      }}
    >
      <div
        className={clsx(
          isExpanded ? "text-gray-600" : "text-transparent",
          "flex-1 truncate whitespace-nowrap"
        )}
      >
        {dayjs(startDate).format("MMM DD")}
      </div>
      <div
        className={clsx(
          isExpanded ? "text-gray-600" : "text-transparent",
          "flex-1 truncate whitespace-nowrap text-right"
        )}
      >
        {dayjs(endDate).format("MMM DD")}
      </div>
    </div>
  );
}

type DragCell = {
  date: string;
};

function ResourceRow({
  resource,
  timeline,
  projectId,
}: // setProjectResourceAllocations,
{
  resource:
    | {
        type: "user";
        user: ProjectResourceAllocationData["users"][0];
      }
    | {
        type: "role";
        role: ProjectResourceAllocationData["roles"][0];
      };
  timeline: TimelineItem[];
  projectId: string;
  // setProjectResourceAllocations: Dispatch<
  //   SetStateAction<ProjectResourceAllocationData[]>
  // >;
}) {
  // const [selectedCells, setSelectedCells] = useState<SelectedCells[]>([]);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState<DragCell | null>(null);
  const [dragEnd, setDragEnd] = useState<DragCell | null>(null);
  const allocatedInMs =
    resource.type === "user"
      ? resource.user.allocations.reduce((acc, allocation) => {
          const weeksInAllocation =
            dayjs(allocation.endDate).diff(allocation.startDate, "week") + 1;
          return acc + allocation.timePerWeek * weeksInAllocation;
        }, 0)
      : resource.type === "role"
      ? resource.role.allocations.reduce((acc, allocation) => {
          const weeksInAllocation =
            dayjs(allocation.endDate).diff(allocation.startDate, "week") + 1;
          return acc + allocation.timePerWeek * weeksInAllocation;
        }, 0)
      : 0;

  // const toggleCell = (projectId: string, weekStartDate: string) => {
  //   // setSelectedCells((prev) => ({
  //   //   ...prev,
  //   //   [projectId]: {
  //   //     ...prev[projectId],
  //   //     [weekStartDate]: !prev[projectId]?.[weekStartDate],
  //   //   },
  //   // }));
  // };

  const handleMouseDown = (weekStartDate: string) => {
    setIsDragging(true);
    setDragStart({ date: weekStartDate });
    setDragEnd({ date: weekStartDate });
  };

  const handleMouseEnter = (weekStartDate: string) => {
    if (isDragging) {
      setDragEnd({ date: weekStartDate });
    }
  };

  const [selectedCells, setSelectedCells] = useState<{
    startDate: string;
    endDate: string;
  } | null>(null);

  const weeksInAllocation: string[] = useMemo(() => {
    let weeks: string[] = [];
    const allocations =
      resource.type === "user"
        ? resource.user.allocations
        : resource.role.allocations;
    for (const allocation of allocations) {
      // get all weeks in the allocation
      const numberOfWeeksInAllocation = dayjs(allocation.startDate).diff(
        allocation.endDate,
        "weeks"
      );
    }
    return weeks;
  }, [resource]);

  useEffect(() => {
    const handleGlobalMouseUp = () => {
      // console.log("mouse up");
      // // console.log(isDragging);
      // console.log(dragStart);
      // console.log(dragEnd);
      if (dragEnd || dragStart) {
        if (dragStart && dragEnd) {
          setSelectedCells({
            startDate: dragStart.date,
            endDate: dragEnd.date,
          });
        }
        setIsDragging(false);
        setDragStart(null);
        setDragEnd(null);
      }
    };

    document.addEventListener("mouseup", handleGlobalMouseUp);
    return () => {
      document.removeEventListener("mouseup", handleGlobalMouseUp);
    };
  }, [dragEnd, dragStart]);

  // console.log(user.allocations);
  const resourcesCtx = useResourcesContext();
  return (
    <div
      className="group flex hover:bg-gray-50"
      key={
        resource.type === "user" ? resource.user.userId : resource.role.roleId
      }
    >
      <div className="group sticky left-0 z-30 flex h-14 shrink-0 items-center truncate border-r-2 border-gray-200 bg-white text-sm font-medium group-hover:bg-gray-50">
        {/* <div
      className={clsx(
        "flex h-6 w-6 shrink-0 items-center justify-center rounded-md transition-all group-hover:bg-gray-100",
        expanded
          ? "text-gray-600"
          : "text-gray-300 group-hover:text-gray-400"
      )}
    >
      <TriangleRightIcon
        className={clsx(
          "h-4 w-4 transition-transform",
          expanded ? "rotate-90" : "rotate-0"
        )}
      />
    </div> */}
        <div
          className={`flex h-full flex-1 items-center gap-2.5 truncate pl-14 pr-8 w-[${PROJECT_COLUMN_WIDTH}px]`}
        >
          {resource.type === "user" ? (
            <div className="shrink-0 flex h-7 w-7 items-center justify-center rounded-full border border-gray-300 bg-gray-200/70 text-xs text-gray-500">
              {getFirstAndLastInitials(resource.user.user.name)}
            </div>
          ) : resource.type === "role" ? (
            <div className="shrink-0 flex h-7 w-7 items-center justify-center rounded-full border border-dashed border-gray-400 text-xs text-gray-500">
              {getFirstAndLastInitials(resource.role.role.name)}
            </div>
          ) : null}
          
          <div className="truncate">
            {resource.type === "user"
              ? resource.user.user.name
              : resource.role.role.name}
          </div>
        </div>
        <div
          className={`flex h-full items-center border-l px-6 w-[${ALLOCATED_COLUMN_WIDTH}px]`}
        >
          {""}
        </div>
        <div
          className={`flex h-full items-center border-l px-6 font-normal w-[${ALLOCATED_COLUMN_WIDTH}px]`}
        >
          {convertMsToHM(allocatedInMs)}
        </div>
      </div>
      <div className="relative flex h-14 w-full">
        {timeline.map((item) => {
          return (
            <div
              key={item.date}
              className={clsx(
                `group/cell relative flex h-14 shrink-0 items-center truncate border-r border-r-gray-100`,
                "cursor-pointer"
              )}
              style={{
                width: `${resourcesCtx.state.dayWidth * 7}px`,
              }}
              onMouseDown={() => {
                if (!weeksInAllocation.includes(item.date)) {
                  handleMouseDown(item.date);
                }
              }}
              onMouseEnter={() => handleMouseEnter(item.date)}
            >
              <div
                className={clsx(
                  `w-full rounded-md group-hover/cell:bg-purple-200`
                  // dragStart?.date === item.date && "rounded-l-md",
                  // dragEnd?.date === item.date && "rounded-r-md",
                  // dragStart?.date &&
                  //   dragEnd?.date &&
                  //   (dayjs(item.date).isSame(dayjs(dragStart.date)) ||
                  //     dayjs(item.date).isAfter(dayjs(dragStart.date))) &&
                  //   (dayjs(item.date).isBefore(dayjs(dragEnd.date)) ||
                  //     dayjs(item.date).isSame(dayjs(dragEnd.date)))
                  //   ? "bg-purple-300"
                  //   : "hover:bg-purple-200"
                  // selectedCells.some((cell) => cell.date === item.date)
                  //   ? "bg-purple-300"
                  //   : ""
                )}
                style={{
                  height: `${RESOURCE_ALLOCATION_HEIGHT}px`, 
                }}
              ></div>
            </div>
          );
        })}
        <TemporaryAllocation
          dragStart={dragStart}
          dragEnd={dragEnd}
          timeline={timeline}
        />
        {resource.type === "user" && (
          <SelectedCells
            selectedCells={selectedCells}
            timeline={timeline}
            setSelectedCells={setSelectedCells}
            projectId={projectId}
            resource={{
              type: "user",
              id: resource.user.userId,
            }}
          />
        )}
        {resource.type === "role" && (
          <SelectedCells
            selectedCells={selectedCells}
            timeline={timeline}
            setSelectedCells={setSelectedCells}
            projectId={projectId}
            resource={{
              type: "role",
              id: resource.role.roleId,
            }}
          />
        )}
        {resource.type === "user" && (
          <ExistingAllocations
            allocations={resource.user.allocations}
            timeline={timeline}
          />
        )}
        {resource.type === "role" && (
          <ExistingAllocations
            allocations={resource.role.allocations}
            timeline={timeline}
          />
        )}
      </div>
    </div>
  );
}

function SelectedCells({
  selectedCells,
  timeline,
  setSelectedCells,
  projectId,
  resource,
}: {
  selectedCells: {
    startDate: string;
    endDate: string;
  } | null;
  timeline: TimelineItem[];
  setSelectedCells: Dispatch<
    SetStateAction<{
      startDate: string;
      endDate: string;
    } | null>
  >;
  projectId: string;
  resource: {
    type: "user" | "role";
    id: string;
  };
}) {
  const resourcesCtx = useResourcesContext();
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<"soft" | "hard">("hard");
  const [timePerWeek, setTimePerWeek] = useState("40h");

  useEffect(() => {
    setOpen(!!selectedCells);
  }, [selectedCells]);

  const createAllocationMutation = useCreateResourceAllocation();

  useEffect(() => {
    if (createAllocationMutation.isSuccess) {
      setSelectedCells(null);
    }
  }, [createAllocationMutation.isSuccess]);

  useEffect(() => {
    if (!selectedCells) {
      setType("hard");
    }
  }, [selectedCells]);
  // console.log(open);
  if (!selectedCells) return null;
  // console.log(!!selectedCells);
  const startIndex = timeline.findIndex((item) =>
    dayjs(item.date).isSame(selectedCells?.startDate, "date")
  );
  if (startIndex === -1) return null;
  const endIndex = timeline.findIndex((item) =>
    dayjs(item.date).isSame(selectedCells?.endDate, "date")
  );
  if (endIndex === -1) return null;
  const weeksInAllocation = endIndex - startIndex + 1;
  const width = weeksInAllocation * resourcesCtx.state.dayWidth * 7;

  return (
    <Popover
      open={open}
      onOpenChange={(open) => {
        if (!open) {
          setSelectedCells(null);
        }
        setOpen(open);
      }}
    >
      <PopoverTrigger asChild>
        <div
          className={clsx(
            `absolute top-1/2 left-0 z-10 -translate-y-1/2 cursor-pointer overflow-hidden rounded-md bg-purple-300`,
            type === "soft" && "border border-purple-400"
          )}
          style={{
            left: `${startIndex * resourcesCtx.state.dayWidth * 7}px`,
            width: `${width - 1}px`,
            height: `${RESOURCE_ALLOCATION_HEIGHT}px`,
          }}
        >
          {type === "soft" && (
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <pattern
                  id="diagonalStripe"
                  patternUnits="userSpaceOnUse"
                  width="10"
                  height="10"
                  patternTransform="rotate(45)"
                >
                  <line
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="10"
                    stroke="#f3e8ff"
                    strokeWidth="5"
                  />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="#e9d5ff" />
              <rect width="100%" height="100%" fill="url(#diagonalStripe)" />
            </svg>
          )}
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-fit p-6">
        <div className="space-y-6">
          <div className="space-y-0.5">
            <div className="text-xs text-gray-600">Dates</div>
            <div className="text-sm">
              <span className="font-medium">
                {dayjs(selectedCells.startDate).format("MMM DD")}
              </span>
              <span>{" - "}</span>
              <span className="font-medium">
                {dayjs(selectedCells.endDate)
                  .add(1, "week")
                  .subtract(1, "day")
                  .format("MMM DD")}
              </span>
              <span className="text-gray-500">{` (${weeksInAllocation} weeks)`}</span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="space-y-1">
              <div className="text-xs text-gray-600">Time per week</div>
              <TextInput
                value={timePerWeek}
                onChange={(e) => setTimePerWeek(e.target.value)}
                onBlur={() => {
                  const parsedTime = parse(timePerWeek);
                  if (parsedTime === undefined) {
                    setTimePerWeek("0h 0m");
                  } else {
                    setTimePerWeek(convertMsToNatural(parsedTime));
                  }
                }}
                placeholder="e.g. 40h 00m"
                className="w-40"
              />
            </div>
            <div className="space-y-1">
              <div className="text-xs text-gray-600">Total time</div>
              <TextInput
                value={convertMsToNatural(
                  (parse(timePerWeek) ?? 0) * weeksInAllocation
                )}
                // onChange={(e) => setTimePerWeek(e.target.value)}
                // onBlur={() => {
                //   const parsedTime = parse(timePerWeek);
                //   console.log(parsedTime);
                //   if (parsedTime === undefined) {
                //     setTimePerWeek("0h 0m");
                //   } else {
                //     setTimePerWeek(convertMsToNatural(parsedTime));
                //   }
                // }}
                disabled
                // placeholder="e.g. 40h 00m"
                className="w-40"
              />
            </div>
            <div className="space-y-1">
              <div className="text-xs text-gray-600">Allocation Type</div>
              <Select
                value={type}
                onValueChange={(value) => setType(value as "soft" | "hard")}
              >
                <SelectTrigger className="h-9 w-40">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="hard">Hard</SelectItem>
                  <SelectItem value="soft">Soft</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="flex justify-end space-x-2 pt-4">
            <Button
              variant={"secondary"}
              onClick={() => {
                setSelectedCells(null);
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={
                parse(timePerWeek) === undefined ||
                createAllocationMutation.isLoading
              }
              onClick={() => {
                if (resource.type === "user") {
                  createAllocationMutation.mutate({
                    phaseId: projectId,
                    userId: resource.id,
                    allocationType: type,
                    startDate: selectedCells.startDate,
                    endDate: selectedCells.endDate,
                    timePerWeek: parse(timePerWeek) ?? 0,
                  });
                } else {
                  createAllocationMutation.mutate({
                    phaseId: projectId,
                    roleId: resource.id,
                    allocationType: type,
                    startDate: selectedCells.startDate,
                    endDate: selectedCells.endDate,
                    timePerWeek: parse(timePerWeek) ?? 0,
                  });
                }
              }}
            >
              {createAllocationMutation.isLoading
                ? "Creating..."
                : "Create Allocation"}
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}

function TemporaryAllocation({
  dragStart,
  dragEnd,
  timeline,
}: {
  dragStart: DragCell | null;
  dragEnd: DragCell | null;
  timeline: TimelineItem[];
}) {
  const resourcesCtx = useResourcesContext();
  if (!dragStart || !dragEnd) return null;
  const startIndex = timeline.findIndex((item) =>
    dayjs(item.date).isSame(dragStart?.date, "date")
  );
  if (startIndex === -1) return null;
  const endIndex = timeline.findIndex((item) =>
    dayjs(item.date).isSame(dragEnd?.date, "date")
  );
  if (endIndex === -1) return null;
  const weeksInAllocation = endIndex - startIndex + 1;
  const width = weeksInAllocation * resourcesCtx.state.dayWidth * 7;
  return (
    <div
      className={`absolute top-1/2 left-0 z-10 -translate-y-1/2 cursor-ew-resize rounded-md bg-purple-200`}
      style={{
        left: `${startIndex * resourcesCtx.state.dayWidth * 7}px`,
        width: `${width - 1}px`,
        height: `${RESOURCE_ALLOCATION_HEIGHT}px`,
      }}
    />
  );
}

const Overlay = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 9999,
      // Semi-transparent overlay
      // backgroundColor: 'rgba(0, 0, 0, 0.1)',
      cursor: "ew-resize",
    }}
  />
);

function ExistingAllocations({
  allocations,
  timeline,
}: {
  allocations: ProjectResourceAllocationData["users"][0]["allocations"];
  timeline: TimelineItem[];
}) {
  const resourcesCtx = useResourcesContext();
  return (
    <>
      {allocations.map((allocation, index) => {
        // console.log(allocation.startDate);
        // console.log(dayjs("2024-08-04").toISOString());
        // console.log(dayjs("2024-08-04").isSame("2024-08-04T00:00:00.000Z", "day"));
        // console.log(timeline);
        return (
          <AllocationBar
            key={index}
            allocation={allocation}
            timeline={timeline}
          />
        );
        // } else {
        //   return (
        //     <div
        //       key={index}
        //       className={`absolute top-1/2 left-0 z-10 h-[${RESOURCE_ALLOCATION_HEIGHT}px] -translate-y-1/2 overflow-hidden rounded-md border border-purple-400 bg-gradient-to-r from-purple-100 to-purple-400`}
        //       style={{
        //         left: `${startIndex * resourcesCtx.state.dayWidth * 7}px`,
        //         width: `${width - 1}px`,
        //       }}
        //     >
        //       <svg
        //         width="100%"
        //         height="100%"
        //         xmlns="http://www.w3.org/2000/svg"
        //       >
        //         <defs>
        //           <pattern
        //             id="diagonalStripe"
        //             patternUnits="userSpaceOnUse"
        //             width="10"
        //             height="10"
        //             patternTransform="rotate(45)"
        //           >
        //             <line
        //               x1="0"
        //               y1="0"
        //               x2="0"
        //               y2="10"
        //               stroke="#f3e8ff"
        //               strokeWidth="5"
        //             />
        //           </pattern>
        //         </defs>
        //         <rect width="100%" height="100%" fill="#e9d5ff" />
        //         <rect width="100%" height="100%" fill="url(#diagonalStripe)" />
        //       </svg>
        //       <div className="absolute top-1/2 left-2 -translate-y-1/2 text-sm">
        //         {convertMsToNatural(allocation.timePerWeek, true) + " / w"}
        //       </div>
        //     </div>
        //   );
        // }
      })}
    </>
  );
}

function AllocationBar({
  allocation,
  timeline,
}: {
  allocation: ProjectResourceAllocationData["users"][0]["allocations"][0];
  timeline: TimelineItem[];
}) {
  const resourceCtx = useResourcesContext();
  const deleteResourceAllocationMutation = useDeleteResourceAllocation();
  const updateResourceAllocationMutation = useUpdateResourceAllocation();
  const resourcesCtx = useResourcesContext();
  const [startIndex, setStartIndex] = useState(
    timeline.findIndex((item) =>
      dayjs(item.date).isSame(allocation.startDate, "day")
    )
  );

  useEffect(() => {
    setStartIndex(
      timeline.findIndex((item) =>
        dayjs(item.date).isSame(allocation.startDate, "day")
      )
    );
  }, [timeline, allocation]);
  const [optionsOpen, setOptionsOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [weeksInAllocation, setWeeksInAllocation] = useState(
    dayjs(allocation.endDate).diff(allocation.startDate, "week") + 1
  );

  useEffect(() => {
    setWeeksInAllocation(
      dayjs(allocation.endDate).diff(allocation.startDate, "week") + 1
    );
  }, [allocation]);

  const containerRef = useRef<HTMLDivElement>(null);
  const handleMouseDownRight = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.preventDefault();
    setIsDraggingRight(true);
  };

  const handleMouseDownLeft = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.preventDefault();
    setIsDraggingLeft(true);
  };

  // const handleMouseUp = () => {
  //   setIsDraggingRight(false);
  //   setIsDraggingLeft(false);
  // };

  const width = weeksInAllocation * resourcesCtx.state.dayWidth * 7;
  const [isDraggingRight, setIsDraggingRight] = useState(false);
  const [isDraggingLeft, setIsDraggingLeft] = useState(false);

  const handleMouseMove = (e: MouseEvent) => {
    const mouseX = e.clientX;
    const containerX = containerRef.current?.getBoundingClientRect().x;
    const containerRight = containerRef.current?.getBoundingClientRect().right;
    const width = containerRef.current?.getBoundingClientRect().width;
    e.preventDefault();
    if (isDraggingRight && containerX !== undefined && mouseX > containerX) {
      const newWidth = mouseX - containerX;
      const allocatedWeeks = Math.round(
        newWidth / (resourcesCtx.state.dayWidth * 7)
      );
      if (allocatedWeeks !== weeksInAllocation) {
        setWeeksInAllocation(allocatedWeeks);
      }
    } else if (
      isDraggingLeft &&
      containerRight !== undefined &&
      mouseX < containerRight &&
      width !== undefined
    ) {
      const newWidth = containerRight - mouseX;
      // console.log(
      //   containerX,
      //   mouseX,
      //   weeksInAllocation * resourcesCtx.state.dayWidth * 7
      // );
      // console.log(newWidth);
      const allocatedWeeks = Math.round(
        newWidth / (resourcesCtx.state.dayWidth * 7)
      );
      if (allocatedWeeks !== weeksInAllocation) {
        setWeeksInAllocation(allocatedWeeks);
        setStartIndex(startIndex - (allocatedWeeks - weeksInAllocation));
      }
    }
  };

  const handleMouseUp = () => {
    if (isDraggingRight) {
      const oldWeeksInAllocation =
        dayjs(allocation.endDate).diff(allocation.startDate, "week") + 1;
      const newWeeksInAllocation = weeksInAllocation;
      const increase = newWeeksInAllocation - oldWeeksInAllocation;

      if (increase !== 0) {
        const newEndDate = dayjs(allocation.endDate)
          .add(increase, "week")
          .format("YYYY-MM-DD");
        // console.log(allocation.endDate, newEndDate);
        updateResourceAllocationMutation.mutate({
          allocationGroupId: allocation.allocationGroupId,
          endDate: newEndDate,
          startDate: allocation.startDate,
        });
        // if (increase > 0) {
        //   // extend end date

        // } else {
        //   // reduce end date
        //   const newEndDate = dayjs(allocation.endDate)
        //     .subtract(-increase, "week")
        //     .format("YYYY-MM-DD");
        //   console.log(allocation.endDate, newEndDate);
        //   updateResourceAllocationMutation.mutate({
        //     allocationGroupId: allocation.allocationGroupId,
        //     endDate: newEndDate,
        //   });
        // }
      }
      setIsDraggingRight(false);
    } else {
      const oldWeeksInAllocation =
        dayjs(allocation.endDate).diff(allocation.startDate, "week") + 1;
      const newWeeksInAllocation = weeksInAllocation;
      const increase = newWeeksInAllocation - oldWeeksInAllocation;
      if (increase !== 0) {
        const newStartDate = dayjs(allocation.startDate)
          .subtract(increase, "week")
          .format("YYYY-MM-DD");
        // console.log(allocation);
        // console.log(allocation.startDate, newStartDate);
        // console.log(allocation.startDate);
        updateResourceAllocationMutation.mutate({
          allocationGroupId: allocation.allocationGroupId,
          startDate: newStartDate,
          endDate: allocation.endDate,
        });
      }
      setIsDraggingLeft(false);
    }
    // if (weeksInAllocation !== allocation.timePerWeek) {
    //   updateResourceAllocationMutation.mutate({
    //     allocationGroupId: allocation.allocationGroupId,
    //     timePerWeek: weeksInAllocation,
    //   });
    // }
  };

  useEffect(() => {
    // handle drag end with mouse up

    if (isDraggingRight || isDraggingLeft) {
      window.addEventListener("mouseup", handleMouseUp);
      window.addEventListener("mousemove", handleMouseMove);
    } else {
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("mousemove", handleMouseMove);
    }
    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isDraggingRight, isDraggingLeft, weeksInAllocation]);
  // console.log(allocation);
  // if (allocation.allocationType === "hard") {

  if (startIndex === -1) return null;
  return (
    <>
      {(isDraggingRight || isDraggingLeft) &&
        ReactDOM.createPortal(<Overlay />, document.body)}

      <div
        ref={containerRef}
        className={clsx(
          `absolute top-1/2 left-0 group/allocation -translate-y-1/2 cursor-default overflow-hidden rounded-md`,
          allocation.allocationType === "soft"
            ? "border border-purple-300 bg-purple-100"
            : "border border-purple-400 bg-purple-300",
          (isDraggingRight || isDraggingLeft) && "cursor-ew-resize",
          isDraggingRight ? "z-20" : "z-10"
        )}
        style={{
          left: `${startIndex * resourcesCtx.state.dayWidth * 7}px`,
          width: `${width - 1}px`,
          height: `${RESOURCE_ALLOCATION_HEIGHT}px`,
        }}
      >
        {/* {allocation.allocationType === "soft" && (
        <svg
          width="100%"
          height="100%"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern
              id="diagonalStripe"
              patternUnits="userSpaceOnUse"
              width="10"
              height="10"
              patternTransform="rotate(45)"
            >
              <line
                x1="0"
                y1="0"
                x2="0"
                y2="10"
                stroke="#f3e8ff"
                strokeWidth="5"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="#e9d5ff" />
          <rect width="100%" height="100%" fill="url(#diagonalStripe)" />
        </svg>
      )} */}
        <div
          onMouseDown={handleMouseDownLeft}
          className={clsx(
            "group/leftDrag absolute inset-y-0 left-0 items-center pl-1 pr-2 text-sm hover:cursor-ew-resize group-hover/allocation:flex",
            isDraggingLeft ? "flex" : "hidden"
          )}
        >
          <div
            className={clsx(
              "z-30 h-5 w-[2px] rounded-full",
              allocation.allocationType === "soft"
                ? "group-hover/leftDrag:bg-purple-300"
                : "group-hover/leftDrag:bg-white",
              allocation.allocationType === "hard" &&
                (isDraggingLeft ? "bg-white" : "bg-white/70"),
              // : "bg-white/70",
              allocation.allocationType === "soft" &&
                (isDraggingLeft ? "bg-purple-300" : "bg-purple-300/70")
            )}
          />
        </div>
        <div
          onMouseDown={handleMouseDownRight}
          className={clsx(
            "group/rightDrag absolute inset-y-0 right-0 items-center pl-2 pr-1 text-sm hover:cursor-ew-resize group-hover/allocation:flex",
            isDraggingRight ? "flex" : "hidden"
          )}
        >
          <div
            className={clsx(
              "z-30 h-5 w-[2px] rounded-full",
              allocation.allocationType === "soft"
                ? "group-hover/rightDrag:bg-purple-300"
                : "group-hover/rightDrag:bg-white",
              allocation.allocationType === "hard" &&
                (isDraggingRight ? "bg-white" : "bg-white/70"),
              // : "bg-white/70",
              allocation.allocationType === "soft" &&
                (isDraggingRight ? "bg-purple-300" : "bg-purple-300/70")
              // : "bg-purple-300/70"
            )}
          />
        </div>
        <DropdownMenu
          open={optionsOpen}
          onOpenChange={(isOpen) => {
            setOptionsOpen(isOpen);
          }}
        >
          <DropdownMenuTrigger asChild>
            <div
              className={clsx(
                "group/options absolute top-1/2 right-3 z-20 flex h-6 w-5 -translate-y-1/2 items-center justify-center rounded text-sm opacity-0 hover:cursor-pointer group-hover/allocation:opacity-100",
                allocation.allocationType === "soft"
                  ? "bg-purple-100 hover:bg-[#EDDDFF] group-hover/allocation:opacity-100"
                  : "bg-purple-300 hover:bg-[#CD9DFD] group-hover/allocation:opacity-100",
                optionsOpen && "opacity-100",
                allocation.allocationType === "soft" &&
                  optionsOpen &&
                  "bg-purple-200",
                allocation.allocationType === "hard" &&
                  optionsOpen &&
                  "bg-purple-400"
              )}
            >
              <EllipsisVerticalIcon
                className={clsx(
                  "h-[18px] shrink-0",
                  allocation.allocationType === "soft"
                    ? "text-primary/70 group-hover/options:text-primary"
                    : "text-white/70 group-hover/options:text-white"
                )}
              />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-44" align="end" sideOffset={8}>
            <DropdownMenuGroup>
              <DropdownMenuItem
                className="py-1"
                // className="py-1 focus:bg-gray-50 focus:text-red-600"
                onClick={(e) => {
                  // setIsEditing(true);
                }}
              >
                <Pencil2Icon className="h-3.5 w-3.5 shrink-0" />
                <span className="ml-2 text-sm">Edit</span>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                // className="py-1 focus:bg-gray-50 focus:text-red-600"
                className="py-1 focus:bg-red-50 focus:text-red-600"
                onClick={(e) => {
                  setDeleteOpen(true);
                }}
              >
                <TrashIcon className="h-3.5 w-3.5 shrink-0" />
                <span className="ml-2 text-sm">Delete</span>
              </DropdownMenuItem>

              {/* <DropdownMenuItem>Delete</DropdownMenuItem> */}
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>

        <div className="absolute top-1/2 left-3 max-w-[calc(60%)] -translate-y-1/2 truncate whitespace-nowrap text-xs">
          {convertMsToNatural(allocation.timePerWeek, true) + " / w"}
        </div>
        <Dialog
          open={deleteOpen}
          onOpenChange={(isOpen) => {
            setDeleteOpen(isOpen);
          }}
        >
          <DialogContent>
            <div className="pb-4">
              <div>Are you sure you want to delete the allocation?</div>
            </div>
            <div className="flex justify-end space-x-2">
              <Button
                variant={"secondary"}
                onClick={() => {
                  setDeleteOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant={"destructive"}
                onClick={() => {
                  deleteResourceAllocationMutation.mutate({
                    allocationGroupId: allocation.allocationGroupId,
                  });
                  setDeleteOpen(false);
                }}
              >
                Delete
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}
